import React, { useEffect, useState } from 'react';
import { useAuth } from '../../App';
import ReactDOM from 'react-dom';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";


import './account.css';

export default function Account() {
  const { user, logout } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [profile, setProfile] = useState(null);
  const [children, setChildren] = useState([]);
  const [myClass, setMyClass] = useState(null);
  const [myClassName, setMyClassName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    async function load() {
      if (!apiUrl) return setMsg('API not configured');
      const token = localStorage.getItem('token');
      if (!token) return setMsg('You must to be logged in to view this page');
      setLoading(true);
      try {
        // fetch fresh profile from server to include full fields
        const meRes = await fetch(`${apiUrl}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        let fetchedProfile = null;
        if (meRes.ok) {
          const md = await meRes.json();
          fetchedProfile = md.user || md;
          if (mounted) setProfile(fetchedProfile);
        } else {
          fetchedProfile = user;
          if (mounted) setProfile(user);
        }
        if (user && user.role && user.role.toLowerCase() === 'teacher') {
          // fetch classes to find teacher's class
          // NOTE: Previously we fell back to the first class in the list which caused an unrelated
          // class to be shown when a teacher had no assigned class. Instead we only set myClass
          // when we find a class whose teacher_username matches the current user. As a secondary
          // fallback we try to resolve by the profile.class_id (if available).
          const res = await fetch(`${apiUrl}/api/classes`, { headers: { Authorization: `Bearer ${token}` } });
          if (res.ok) {
            const data = await res.json();
            const clsList = data.classes || [];
            // find class assigned to this teacher
            let cls = clsList.find(c => c.teacher_username === user.username) || null;
            // secondary fallback: if profile indicates a class_id, try to resolve that
            if (!cls && (fetchedProfile && fetchedProfile.class_id)) {
              cls = clsList.find(c => String(c.id) === String(fetchedProfile.class_id)) || null;
            }
            if (mounted) setMyClass(cls);
          }
        } else if (user && user.role && user.role.toLowerCase() === 'parent') {
          // fetch children (server should expose GET /api/me/children)
          const cres = await fetch(`${apiUrl}/api/me/children`, { headers: { Authorization: `Bearer ${token}` } });
          if (cres.ok) {
            const cd = await cres.json();
            if (mounted) setChildren(cd.children || []);
          }
        }
        // resolve class name for any profile that has class_id
        const profForClass = fetchedProfile || profile;
        if (mounted && profForClass && profForClass.class_id) {
          try {
            const cres2 = await fetch(`${apiUrl}/api/classes`, { headers: { Authorization: `Bearer ${token}` } });
            if (cres2.ok) {
              const cd2 = await cres2.json();
              const cls2 = (cd2.classes || []).find(c => String(c.id) === String(profForClass.class_id));
              if (cls2) {
                // store full class object so we can display teacher details as well
                setMyClass(cls2);
                setMyClassName(cls2.name || null);
              }
            }
          } catch (e) { /* ignore */ }
        }
      } catch (e) { console.error(e); if (mounted) setMsg('Can not loading profile...'); }
      finally { if (mounted) setLoading(false); }
    }
    load();
    return () => { mounted = false; };
  }, [apiUrl, user]);

  console.log(user)
  // decide appropriate ID label depending on role (students should see "Student's ID")
  const idLabel = (profile && profile.role && String(profile.role).toLowerCase() === 'student') ? "Student's ID" : "Teacher's ID";
  // change password
  const handleChangePassword = async (e) => {
    e.preventDefault();
    const form = e.target;
    const current = form.current.value;
    const next = form.next.value;
    if (!current || !next) return setMsg('Please fill in both current and new password');
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/api/auth/change-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ current, next })
      });
      if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.message || 'Failed'); }
      setMsg('Change password successfully');
      form.reset();
    } catch (e) { console.error(e); setMsg(e.message || 'Failed to change password'); }
  };

  return (
    <div className="account-page page-view">
      <div className="year-text">Year 2025-2026</div>
      {loading && <div className="muted">Loading...</div>}
      {profile && (
        <div className="account-section profile-summary">
          <h3>Profile Information</h3>
          <div className="status-badge">{profile.status || 'Active'}</div>
          <div className="profile-row">
            <div className="profile-avatar">
              {profile.avt ? (
                <img src={(profile.avt && profile.avt.startsWith('/')) ? (apiUrl ? apiUrl.replace(/\/$/, '') + profile.avt : profile.avt) : profile.avt} alt="avatar" height={50} width={50} />
              ) : (
                <div className="avatar-placeholder">No avatar</div>
              )}
            </div>
            <div className="profile-fields">
              <div className="name">
                <div style={{ fontWeight: 700, fontSize: 16 }}>{(profile && (profile.last_name || profile.first_name)) ? [profile.last_name, profile.first_name].filter(Boolean).join(' ') : (profile.full_name || profile.username)}</div>
                <div className="muted" style={{ fontSize: 13 }}>{profile.role || ''}</div>
              </div>
              <div className="profile-info-grid">
                <p><strong>Username:</strong> <span>{profile.username || 'No information'}</span></p>
                <p><strong>Class:</strong> <span>{myClassName || (profile.class_id ? profile.class_id : 'No information')}</span></p>
                <p><strong>Email:</strong> <span>{profile.email || 'No information'}</span></p>
                <p><strong>{idLabel}:</strong> <span>{profile.identifier_code || 'No information'}</span></p>
                <p><strong>School:</strong> <span>{profile.school_name || 'No information'}</span></p>
                <p><strong>Phone number:</strong> <span>{profile.phone || 'No information'}</span></p>
              </div>
            </div>
          </div>
        </div>
      )}

      {user && user.role && (user.role.toLowerCase() === 'teacher' || user.role.toLowerCase() === 'student') && (
        <div className="account-section">
          <h3>Class Information</h3>
          {(myClass || myClassName) ? (
            <div>
              <p><strong>School:</strong> {profile?.school_name || (myClass ? (myClass.school || myClass.school_name) : null) || 'No information'}</p>
              <p><strong>Class:</strong> {(myClass && myClass.name) ? myClass.name : (myClassName || (profile && profile.class_id) ? String(profile.class_id) : 'No information')}</p>
              <div style={{ marginTop: 16 }}>
                <strong>Teacher:</strong>
                {myClass ? (
                  myClass.teacher_full_name ? (` ${myClass.teacher_full_name}`) : ((myClass.teacher_last_name || myClass.teacher_first_name) ? (` ${[myClass.teacher_last_name, myClass.teacher_first_name].filter(Boolean).join(' ')}`) : (myClass.teacher_username ? (` ${myClass.teacher_username}`) : ''))
                ) : (
                  ` ${(profile && (profile.last_name || profile.first_name)) ? [profile.last_name, profile.first_name].filter(Boolean).join(' ') : (profile && profile.full_name) || profile && profile.username || ''}`
                )}
              </div>
            </div>
          ) : <p className="muted">No class found</p>}
        </div>
      )}

      <div className="account-section">
        <h3>Change Password</h3>
        <form onSubmit={handleChangePassword} className="pw-form">
          <div>
            <label>Current password</label>
            <input name="current" type="password" />
          </div>
          <div>
            <label>New password</label>
            <input name="next" type="password" />
          </div>
          <div>
            <button type="submit">Change Password</button>
          </div>
        </form>
        <div className="pw-form-hint">
          <div className="hint">Password must be at least 8 characters long and include both letters and numbers.</div>
        </div>
        {msg && <div className="info">{msg}</div>}
      </div>

      <div className="account-section">
        <h3>Forgot Password</h3>
        <i>If you forgot your password, contact support through your Teacher (not implemented here).</i>
      </div>
      {(user && user.role && String(user.role).toLowerCase() === 'student') && (
        <div className='account-section-action'>
          <>
            <button
              className="btn logout-btn"
              onClick={() => setShowConfirm(true)}
            >
              Logout
            </button>
            {showConfirm && ReactDOM.createPortal(
              <div className="confirm-modal" onClick={() => setShowConfirm(false)}>
                <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
                  <p>Are you sure you want to logout?</p>
                  <div className="confirm-actions">
                    <button className="btn cancel" onClick={() => setShowConfirm(false)}>Cancel</button>
                    <button
                      className="btn confirm"
                      onClick={() => {
                        logout();
                        setShowConfirm(false);
                        try { navigate('/login'); } catch (e) { /* ignore */ }
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>,
              document.body
            )}
          </>
        </div>
      )}
    </div>
  );
}
